export class PaginationScrollExtension {
	initialize(naja) {
		naja.snippetHandler.addEventListener("afterUpdate", (event) => {
			if (event.detail.snippet.dataset.slideTo) {
				this.scrollToTop(event.detail.snippet.dataset.slideTo);
			}
		});
	}

	scrollToTop(id) {
		const scrollToElement = document.getElementById(id);

        if (scrollToElement) {
            scrollToElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
}
